
























































import Vue, {PropType} from 'vue'
import {secondsToHms} from "@/ts/utils";
import {ModelStat, TestResult} from "@/ts/types";

const gradients = [
    ['#222'],
    ['#42b3f4'],
    ['red', 'orange', 'yellow'],
    ['purple', 'violet'],
    ['#00c6ff', '#F0F', '#FF0'],
    ['#1feaea', '#ffd200', '#f72047'],
]

export default Vue.extend({
    name: 'TestResultView',
    props: {
        result: {
            type: Object as PropType<TestResult>,
            required: true,
        },
        learnResult: {
            type: Boolean,
            default: false,
        },
        subsetId: {
            type: Number,
            default: null,
        },
    },
    data: () => ({
        lineConfig: {
            width: 2,
            radius: 10,
            padding: 8,
            lineCap: 'round',
            gradient: gradients[5],
            gradientDirection: 'top',
            gradients,
            fill: false,
            type: 'trend',
            autoLineWidth: false,
        },
    }),
    async mounted() {
        console.log('model stats', this.$store.state.modelStats);
    },
    methods: {
        toHms(s: number) {
            return secondsToHms(s);
        },
    },
    computed: {
        rollingAccuracyHistory(): number[] {
            return this.result?.history.map((h: any) => h.rollingAccuracy) ?? [];
        },
        accuracyHistory(): number[] {
            return this.result?.history.map((h: any) => h.accuracy) ?? [];
        },
        minRollingAccuracy(): number {
            return Math.min(...this.rollingAccuracyHistory);
        },
        maxRollingAccuracy(): number {
            return Math.max(...this.rollingAccuracyHistory);
        },
        countries(): { [key: string]: string }[] {
            return this.$store.state.countries;
        },
        randomFlags(): string[] {
            return this.$store.state.randomFlags;
        },
        correctPercentage(): number {
            if (!this.result?.history.length) return 0;
            console.log('result history', this.result.history);
            let correctCount = this.result?.history.reduce((a, b) => a + (b.correct ? 1 : 0), 0);
            return correctCount / this.result?.history.length;
        },
    },
})
